<template>
  <svg
    class="h-12 w-12 text-vice-teal-600"
    width="28"
    height="28"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10" stroke="#14B8A6" stroke-width="0.5" fill="#E5E7EB" />
    <path
      d="M15.4137 10.941C16.1954 11.4026 16.1954 12.5974 15.4137 13.059L10.6935 15.8458C9.93371 16.2944 9 15.7105 9 14.7868L9 9.21316C9 8.28947 9.93371 7.70561 10.6935 8.15419L15.4137 10.941Z"
      stroke="currentColor"
      stroke-width="1"
      fill="currentColor"
    />
  </svg>
</template>
